import { render, staticRenderFns } from "./PageTurner.vue?vue&type=template&id=f41d4cce&"
import script from "./PageTurner.vue?vue&type=script&lang=ts&"
export * from "./PageTurner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports